(() => {
  const initCategoryLanding = (root) => {
    if (!root || root.dataset.fclReady === 'true') return;
    root.dataset.fclReady = 'true';

    const grid = root.querySelector('[data-fcl-grid]');
    const cards = grid ? Array.from(grid.querySelectorAll('[data-fcl-product]')) : [];
    const pills = Array.from(root.querySelectorAll('[data-fcl-filter]'));
    const sort = root.querySelector('[data-fcl-sort]');
    const empty = root.querySelector('[data-fcl-empty]');
    const originalOrder = new Map(cards.map((card, index) => [card, index]));
    let activeFilter = 'all';

    const matchesFilter = (card) => {
      if (activeFilter === 'all') return true;
      const text = (card.dataset.search || '').toLowerCase();
      const aliases = {
        bulb: ['bulb', 'b22', 'e27', 'e14', 'spotlight', 'downlight'],
        motion: ['motion', 'pir', 'sensor'],
        night: ['night'],
        ambient: ['ambient', 'strip', 'colour', 'color', 'rgb'],
        bundle: ['bundle', 'starter', 'pack']
      };
      const terms = aliases[activeFilter] || [activeFilter.replace(/-/g, ' ')];
      return terms.some((term) => text.includes(term));
    };

    const updateVisibility = () => {
      let visibleCount = 0;
      cards.forEach((card) => {
        const visible = matchesFilter(card);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      if (empty) empty.hidden = visibleCount !== 0;
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        activeFilter = pill.dataset.fclFilter || 'all';
        pills.forEach((item) => {
          const active = item === pill;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        updateVisibility();
      });
    });

    if (sort && grid) {
      sort.addEventListener('change', () => {
        const ordered = [...cards];
        if (sort.value === 'price-asc') {
          ordered.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
        } else if (sort.value === 'price-desc') {
          ordered.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
        } else if (sort.value === 'title') {
          ordered.sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || ''));
        } else {
          ordered.sort((a, b) => originalOrder.get(a) - originalOrder.get(b));
        }
        ordered.forEach((card) => grid.appendChild(card));
      });
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-fcl-page]').forEach(initCategoryLanding);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
